import { ThemeOptions } from '@mui/material';

import { tokens } from '../../theme/generated/tokens';
import { cssVars } from '../../utils/cssVars';

const vars = cssVars(
  {
    color: undefined,
    borderColor: undefined,
    backgroundColor: undefined,
    titleFontSize: undefined,
    titleLineHeight: undefined,
    bodyFontSize: undefined,
    bodyLineHeight: undefined,
    iconSize: undefined,
  },
  'ds-alert'
);

export const alertsTheme: ThemeOptions['components'] = {
  MuiAlertTitle: {
    styleOverrides: {
      root: {
        margin: 0,
        fontWeight: 600,
        color: vars.refs.color,
        fontSize: vars.refs.titleFontSize,
        lineHeight: vars.refs.titleLineHeight,
        '.DsAlert-hasChildren &': {
          marginBottom: '4px',
        },
      },
    },
  },
  DsAlert: {
    styleOverrides: {
      root: {
        padding: '4px 12px',
        border: '1px solid',
        alignItems: 'flex-start',
        borderColor: vars.refs.borderColor,
        backgroundColor: vars.refs.backgroundColor,
        color: vars.refs.color,

        '& .DsAlert-content': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '12px',
        },
        '& .MuiAlert-icon': {
          fontSize: vars.refs.iconSize,
          '& svg': {
            color: vars.refs.color,
          },
        },
        '& .DsAlert-close': {
          fontSize: '16px',
          color: vars.refs.color,

          '&:hover': {
            opacity: 0.7,
            cursor: 'pointer',
          },
          '&:active': {
            opacity: '1',
          },
        },
        '&& .MuiSvgIcon-root': {
          strokeLinecap: 'round',
          fontSize: '16px',
        },
        '& .MuiAlert-action': {
          marginRight: '0',
          paddingTop: 8,
        },
        '& .MuiAlert-message': {
          paddingTop: '7px',
          fontWeight: 400,
          color: vars.refs.color,
          fontSize: vars.refs.bodyFontSize,
          lineHeight: vars.refs.bodyLineHeight,
        },
      },
      filledInfo: vars.setValues({
        color: tokens.theme.fg.status.onInfoSubtle,
        borderColor: tokens.theme.border.status.infoSubtle,
        backgroundColor: tokens.theme.bg.status.infoSubtle,
      }),
      filledAdvisory: vars.setValues({
        color: tokens.theme.fg.status.onNeutralSubtle,
        borderColor: tokens.theme.border.status.neutralSubtle,
        backgroundColor: tokens.theme.bg.status.neutralSubtle,
      }),
      filledSuccess: vars.setValues({
        color: tokens.theme.fg.status.onSuccessSubtle,
        borderColor: tokens.theme.border.status.successSubtle,
        backgroundColor: tokens.theme.bg.status.successSubtle,
      }),
      filledWarning: vars.setValues({
        color: tokens.theme.fg.status.onWarningSubtle,
        borderColor: tokens.theme.border.status.warningSubtle,
        backgroundColor: tokens.theme.bg.status.warningSubtle,
      }),
      filledError: vars.setValues({
        color: tokens.theme.fg.status.onErrorSubtle,
        borderColor: tokens.theme.border.status.errorSubtle,
        backgroundColor: tokens.theme.bg.status.errorSubtle,
      }),
      filledExceptional: vars.setValues({
        color: tokens.theme.fg.status.onDiscoverySubtle,
        borderColor: tokens.theme.border.status.discoverySubtle,
        backgroundColor: tokens.theme.bg.status.discoverySubtle,
      }),
      outlinedInfo: vars.setValues({
        color: tokens.theme.fg.status.info,
        borderColor: tokens.theme.border.status.info,
        backgroundColor: tokens.theme.bg.structural.surface,
      }),
      outlinedAdvisory: vars.setValues({
        color: tokens.theme.fg.status.neutral,
        borderColor: tokens.theme.border.status.neutral,
        backgroundColor: tokens.theme.bg.structural.surface,
      }),
      outlinedSuccess: vars.setValues({
        color: tokens.theme.fg.status.success,
        borderColor: tokens.theme.border.status.success,
        backgroundColor: tokens.theme.bg.structural.surface,
      }),
      outlinedWarning: vars.setValues({
        color: tokens.theme.fg.status.warning,
        borderColor: tokens.theme.border.status.warning,
        backgroundColor: tokens.theme.bg.structural.surface,
      }),
      outlinedError: vars.setValues({
        color: tokens.theme.fg.status.error,
        borderColor: tokens.theme.border.status.error,
        backgroundColor: tokens.theme.bg.structural.surface,
      }),
      outlinedExceptional: vars.setValues({
        color: tokens.theme.fg.status.onDiscoverySubtle,
        borderColor: tokens.theme.border.status.discovery,
        backgroundColor: tokens.theme.bg.structural.surface,
      }),
      small: vars.setValues({
        titleFontSize: '14px',
        titleLineHeight: '22px',
        bodyFontSize: '12px',
        bodyLineHeight: '18px',
        iconSize: '20px',
      }),
      large: vars.setValues({
        titleFontSize: '20px',
        titleLineHeight: '28px',
        bodyFontSize: '14px',
        bodyLineHeight: '22px',
        iconSize: '24px',
      }),
      noIcon: {
        '& .MuiAlert-icon': {
          display: 'none',
        },
      },
    },
  },
};
